import { IconButton } from '@utahdts/utah-design-system';
import './WaterSystemSearchModal.css';
import { useWaterSystemSearchModal } from './WaterSystemSearchModalContext';

const SelectedWaterSystemHeader = ({ selectedWaterSystem }) => {
    // Use only the prop, do not fallback to sessionStorage
    const system = selectedWaterSystem || {};
    const pwsId = system.pwsId;
    const systemName = system.systemName;
    const county = system.countyServed || "";
    const { setShowSystemSelectModal } = useWaterSystemSearchModal();

  return (
    <>
    <div className='utah-design-system' style={{display: 'flex', alignItems: 'center', width: '100%'}}>
      <div>
        <h5>
          {(pwsId && systemName)
            ? `${pwsId} ${systemName}`
            : "No Water System Selected"}
        </h5>
        <p><b>{county}</b></p>
      </div>
      <IconButton
        appearance='borderless'
        color='primary'
        icon={<span className={'utds-icon-before-search'} aria-hidden='true' 
        />}
        style={{alignSelf: 'flex-start', marginLeft: '10px'}}
        onClick={() => {setShowSystemSelectModal(true);}}
        title="water system search"
      />
    </div>
    </>
  );
}

export default SelectedWaterSystemHeader;